import { createFileRoute } from "@tanstack/react-router";
import Precios from "../pages/Precios";

export const Route = createFileRoute("/precios")({
  head: () => ({
    meta: [
      { title: "Precios — Plan Crecé, todo incluido | CreceLocal" },
      {
        name: "description",
        content:
          "Un solo plan a $390.000 ARS/mes. Sitio web, ficha de Google, reseñas, campañas de WhatsApp, seguimiento e inbox unificado. Sin contrato de permanencia. Garantía de 30 días.",
      },
      {
        property: "og:title",
        content: "Precios — Plan Crecé, todo incluido | CreceLocal",
      },
      {
        property: "og:description",
        content:
          "Un solo plan a $390.000 ARS/mes. Sitio web, ficha de Google, reseñas, campañas de WhatsApp, seguimiento e inbox unificado. Sin contrato de permanencia. Garantía de 30 días.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: Precios,
});
